// extracted by mini-css-extract-plugin
export default {"panel":"style_panel__ID1vK","category":"style_category__D0Z85","content":"style_content__s6BBA","group":"style_group__C3jcF"};